import {
  MUTATION_RAISE_NOTIFICATION
} from "@/plugins/store";

export const ACTION_TYPE_OPEN_GAMEINSTANCE = 'gameinstance.open'

export default {
  methods: {
    getActionName(action) {
      return action.title ? action.title : '?';
    },
    performActionResult(result) {
      let message = result.message;
      if (message) {
        this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
          message: message,
          type: result.messageType ? result.messageType : "success"
        });
      }
      if (result.type == ACTION_TYPE_OPEN_GAMEINSTANCE) {
        if (result.uid) {
          this.$router.push({ name: 'competition', params: { gameUID: result.uid } })
        } else {
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: 'ActionResult error. Game uid not given',
            type: "error"
          });
        }
        return true;
      }
      return false;
    }
  }
}
